// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2oyvz","signatureButtonsRight":"ModalSign_signatureButtonsRight__2qjOu"};